import { Button, TextField, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PasswordStrengthReport from '@sophocles/components/PasswordStrengthReport';
import ButtonBox from '@sophocles/views/auth/forms/ButtonBox';
import { MultiFactorCodeField } from '@sophocles/views/auth/forms/fields';

function ResetPasswordForm({ error, challenge, resetStatus, isSubmitting, onSubmit, onCancel, verifyPassword }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');
  const [token, setToken] = useState('');

  let isPasswordValid = true;
  const passwordStatus = verifyPassword(password);
  if (passwordStatus) {
    isPasswordValid = passwordStatus.isValid;
  }

  const passwordsMatch = password === confirmationPassword;

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(password, token);
  };

  const handleCancel = event => {
    event.preventDefault();
    setPassword('');
    setConfirmationPassword('');
    onCancel();
  };

  return (
    <Fragment>
      {resetStatus.required ? (
        <Typography variant="subtitle2" color="gray" align="center" sx={{ mb: '16px', textAlign: 'center' }}>
          {t('auth.resetPasswordIntro', 'You must reset your password to continue logging in.')}
        </Typography>
      ) : null}
      {challenge.parameters.medium && challenge.parameters.destination ? (
        <Typography variant="caption" color="gray" align="center" sx={{ mb: '16px', textAlign: 'center' }}>
          A code was sent via {challenge.parameters.medium.toLowerCase()} to: {challenge.parameters.destination}
        </Typography>
      ) : null}

      <form style={{ display: 'flex', flexDirection: 'column' }} onSubmit={handleSubmit}>
        <MultiFactorCodeField
          id="token"
          name="token"
          value={token}
          onChange={token => setToken(token)}
          error={error}
          disabled={isSubmitting}
          sx={{ mb: 2 }}
        />
        <TextField
          type="password"
          placeholder="Password"
          label="Password"
          name="password"
          autoComplete="new-password"
          value={password}
          error={error}
          onChange={event => setPassword(event.target.value)}
          disabled={isSubmitting}
          sx={{ mb: 2 }}
        />

        <TextField
          type="password"
          placeholder={t('auth.verifyPassword', 'Verify Password')}
          label={t('auth.verifyPassword', 'Verify Password')}
          name="confirmation-password"
          autoComplete="new-password"
          value={confirmationPassword}
          error={error}
          onChange={event => setConfirmationPassword(event.target.value)}
          disabled={isSubmitting}
          sx={{ mb: 2 }}
        />
        {passwordStatus ? <PasswordStrengthReport report={passwordStatus.metrics} /> : null}
        <ButtonBox sx={{ px: 4, my: 2 }}>
          <Button
            variant="contained"
            disabled={
              !isPasswordValid ||
              !passwordsMatch ||
              (password.length === 0 && confirmationPassword.length === 0) ||
              token.length !== 6 ||
              isSubmitting
            }
            color="primary"
            type="submit"
            fullWidth
          >
            {t('actions.submit', 'Submit')}
          </Button>
          <Button
            variant="contained"
            color="error"
            type="cancel"
            disabled={isSubmitting}
            fullWidth
            onClick={handleCancel}
          >
            {t('actions.cancel', 'Cancel')}
          </Button>
        </ButtonBox>
      </form>
    </Fragment>
  );
}

export default ResetPasswordForm;
